/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabAccess from './lab-access';
import LabAccessDetail from './lab-access-detail';
import LabAccessUpdate from './lab-access-update';
import LabAccessDeleteDialog from './lab-access-delete-dialog';

const LabAccessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabAccess />} />
    <Route path="new" element={<LabAccessUpdate />} />
    <Route path=":id">
      <Route index element={<LabAccessDetail />} />
      <Route path="edit" element={<LabAccessUpdate />} />
      <Route path="delete" element={<LabAccessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabAccessRoutes;
